/**
 * 清理指定计时器
 * @param {string} str
 */
export function clearTimer(str) {
  var timers = localStorage.getItem(str);
  if (timers) {
    timers = timers.split(",");
    timers.forEach(item => {
      window.clearTimeout(item);
      window.clearInterval(item);
    });
    localStorage.removeItem(str);
  }
}
/**
 * 保存计时器
 * @param {number} timer
 * @param {string} str
 */
export function saveTimer(timer, str) {
  if (timer !== null && timer !== undefined) {
    let timers = localStorage.getItem(str);
    if (timers && timers.length) {
      timers = timers.split(",");
    } else {
      timers = [];
    }
    if (!timers.includes(timer)) {
      timers.push(timer);
      localStorage.setItem(str, timers);
    }
  }
}
